import { SVGProps } from "react";

function SvgComponent(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="50" height="52" viewBox="0 0 50 52" {...props}>
      <defs>
        <linearGradient id="iao01jh2wa" x1="50%" x2="50%" y1="186.111%" y2="-118.778%">
          <stop offset="0%" stopColor="#27E9DE" />
          <stop offset="52%" stopColor="#03A4EC" />
          <stop offset="100%" stopColor="#2547A8" />
        </linearGradient>
        <linearGradient id="rr0c6h4vlb" x1="49.979%" x2="49.979%" y1="181.962%" y2="-52.394%">
          <stop offset="0%" stopColor="#27E9DE" />
          <stop offset="52%" stopColor="#03A4EC" />
          <stop offset="100%" stopColor="#2547A8" />
        </linearGradient>
        <linearGradient id="se3zykh06c" x1="50%" x2="50%" y1="170.329%" y2="-82.092%">
          <stop offset="0%" stopColor="#27E9DE" />
          <stop offset="52%" stopColor="#03A4EC" />
          <stop offset="100%" stopColor="#2547A8" />
        </linearGradient>
        <linearGradient id="04ckkew41d" x1="50%" x2="50%" y1="94.009%" y2="-176.26%">
          <stop offset="0%" stopColor="#27E9DE" />
          <stop offset="52%" stopColor="#03A4EC" />
          <stop offset="100%" stopColor="#2547A8" />
        </linearGradient>
        <linearGradient id="7y8264vire" x1="148.392%" x2="-84.513%" y1="101.976%" y2="-15.679%">
          <stop offset="0%" stopColor="#27E9DE" />
          <stop offset="52%" stopColor="#03A4EC" />
          <stop offset="100%" stopColor="#2547A8" />
        </linearGradient>
        <linearGradient id="f607ksg9of" x1="141.561%" x2="-131.801%" y1="95.205%" y2="-42.923%">
          <stop offset="0%" stopColor="#27E9DE" />
          <stop offset="52%" stopColor="#03A4EC" />
          <stop offset="100%" stopColor="#2547A8" />
        </linearGradient>
        <linearGradient id="ohzsmttisg" x1="105.034%" x2="-198.179%" y1="109.7%" y2="-218.956%">
          <stop offset="0%" stopColor="#273A9B" />
          <stop offset="56%" stopColor="#202F65" />
          <stop offset="100%" stopColor="#021E2F" />
        </linearGradient>
        <linearGradient id="97q26z13oh" x1="362.516%" x2="-379.361%" y1="389.814%" y2="-418.098%">
          <stop offset="0%" stopColor="#27E9DE" />
          <stop offset="52%" stopColor="#03A4EC" />
          <stop offset="100%" stopColor="#2547A8" />
        </linearGradient>
        <linearGradient id="a9h278rcji" x1="129.142%" x2="8.367%" y1="134.682%" y2="3.757%">
          <stop offset="0%" stopColor="#27E9DE" />
          <stop offset="52%" stopColor="#03A4EC" />
          <stop offset="100%" stopColor="#2547A8" />
        </linearGradient>
      </defs>
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <ellipse cx="20.914" cy="21.767" fill="url(#iao01jh2wa)" rx="20.914" ry="21.767" />
            <path
              fill="url(#rr0c6h4vlb)"
              d="M41.711 19.349c-.805-7.471-5.258-13.98-11.776-17.218-6.52-3.237-14.182-2.745-20.268 1.303l3.648 1.826c4.647 2.329 7.6 7.222 7.599 12.59v25.685c5.953.004 11.626-2.633 15.597-7.25 3.97-4.618 5.862-10.778 5.2-16.936z"
            />
            <path
              fill="url(#se3zykh06c)"
              d="M12.142 41.503c3.545 1.744 7.5 2.382 11.386 1.838V28.77H12.142v12.734z"
            />
            <ellipse cx="32.788" cy="34.175" fill="url(#04ckkew41d)" rx="10.376" ry="10.799" />
            <path
              fill="url(#7y8264vire)"
              d="M34.926 23.606L22.633 36.4c.418 2.118 1.438 4.056 2.928 5.563L40.271 26.7c-1.442-1.568-3.304-2.647-5.345-3.095z"
            />
            <path
              fill="url(#f607ksg9of)"
              d="M28.838 44.152l13.536-14.1c-.216-.533-.472-1.047-.767-1.537L27.35 43.353c.474.308.971.575 1.487.799z"
            />
            <g fill="#FFF" fillRule="nonzero" opacity=".641">
              <path
                d="M0 9L3.507 9 8.516 21.064 13.493 9 17 9 9.216 27 7.818 27zM17 0L0 0 0 3 17 3z"
                transform="translate(12 11)"
              />
            </g>
            <path
              fill="url(#ohzsmttisg)"
              fillRule="nonzero"
              d="M48.102 46.86l-2.185-2.273c-1.09-1.133-1.37-2.862-.697-4.305 1.243-2.621 1.697-5.572 1.302-8.465-1-7.516-7.337-13-14.619-12.653-7.282.348-13.11 6.414-13.444 13.993-.334 7.58 4.936 14.175 12.157 15.215 2.78.411 5.615-.06 8.133-1.354 1.386-.701 3.047-.41 4.136.725l2.324 2.419c.427.445 1.013.685 1.617.662.604-.023 1.172-.307 1.566-.783.725-.974.598-2.366-.29-3.18zM22.866 35.18c-.542-4.314 1.615-8.508 5.364-10.43 3.75-1.922 8.259-1.146 11.214 1.93 2.956 3.076 3.701 7.769 1.854 11.671-1.847 3.903-5.876 6.148-10.02 5.584-4.385-.601-7.835-4.192-8.412-8.755z"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default SvgComponent;
